module.exports = __webpack_public_path__ + "static/media/favicon.c1963aaf.png";